<template>
  <svg width="14" heght="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-3 -3)" fill="none" fill-rule="evenodd">
      <rect width="20" height="20" />
      <g stroke="#000" stroke-width="2">
        <path d="M16.092 3.908L3.908 16.092M16.092 16.092L3.908 3.908" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
